export default __webpack_public_path__ + "static/media/MoverCards.75d39466.gif";